export const StylistStatusBadge = ({ variant = "dark", className = "" }) => {
  const dotColor = "#22c55e";
  const bg =
    variant === "light"
      ? "rgba(255,255,255,0.08)"
      : "rgba(255,255,255,0.06)";
  const border =
    variant === "light"
      ? "1px solid rgba(255,255,255,0.14)"
      : "1px solid rgba(255,255,255,0.12)";

  return (
    <div
      data-testid="stylist-status-badge"
      className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-[12px] md:text-[13px] text-white/85 backdrop-blur-sm ${className}`}
      style={{ background: bg, border }}
    >
      <span className="relative flex items-center justify-center" style={{ width: 8, height: 8 }}>
        <span
          className="absolute inset-0 rounded-full"
          style={{
            background: dotColor,
            opacity: 0.55,
            animation: "stylist-pulse 1.8s ease-out infinite",
          }}
        />
        <span
          className="relative rounded-full"
          style={{ width: 8, height: 8, background: dotColor, boxShadow: `0 0 8px ${dotColor}` }}
        />
      </span>
      <span className="tracking-wide">
        стилист онлайн · <span className="text-white">отвечаем круглосуточно</span>
      </span>
      <style>{`
        @keyframes stylist-pulse {
          0% { transform: scale(1); opacity: 0.55; }
          70% { transform: scale(2.4); opacity: 0; }
          100% { transform: scale(2.4); opacity: 0; }
        }
      `}</style>
    </div>
  );
};
